import {Plugin,PluginKey} from "prosemirror-state"
import {Decoration, DecorationSet} from "prosemirror-view"


function deco(from, to) {
  return Decoration.inline(from, to, {class: "doc-span--transcriptHighlight"})
}

export function transcriptSelectionStylingPlugin(handleSelectionChange){
	return new Plugin({
		key: new PluginKey("transcriptSelectionStylingPlugin"),
		props: {
			decorations(editorState) {
				const selection=editorState.selection
				if(!selection.empty){
					let decoArray=[]
					const selectionDeco=deco(selection.from,selection.to)
					decoArray.push(selectionDeco)
					// console.log('selectionnnnnnnn styling')
					// console.log(selectionDeco)
					// handleSelectionChange(selection)
					return DecorationSet.create(editorState.doc, decoArray)
				}else return null
			}
		},
	})
}
